import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

import type { EntitlementVersion } from '../../../../types';
import './DownloadDetailedReleaseNotes.scss';

export const DownloadDetailedReleaseNotes = ({
  releaseNotes,
}: {
  releaseNotes: EntitlementVersion[];
}) => (
  <div className="download-detailed-release-notes">
    <h2 className="download-detailed-release-notes__title">Release Notes</h2>
    {releaseNotes.map((release) => {
      const { releaseDate, releaseNotes: notes, version } = release;

      return (
        <div key={version} className="download-detailed-release-notes__release">
          <h3 className="download-detailed-release-notes__release-title">
            Version {version}: {releaseDate}
          </h3>
          <div className="download-detailed-release-notes__release-content">
            {parse(DOMPurify.sanitize(notes))}
          </div>
        </div>
      );
    })}
  </div>
);
